import { calculateAlcoholComposition as calculateAlcoholCompositionValue } from "./simple-alcohol";
import { calculateChocolateComposition as calculateChocolateCompositionValue } from "./simple-chocolate";
import { calculateDairyComposition as calculateDairyCompositionValue } from "./simple-dairy";
import { calculateEmulsifierComposition as calculateEmulsifierCompositionValue } from "./simple-emulsifier";
import { calculateStabilizerComposition as calculateStabilizerCompositionValue } from "./simple-stabilizer";
import { calculateSweetenerComposition as calculateSweetenerCompositionValue } from "./simple-sweetener";
import { ingredientValueToDisplay, type IngredientNumericField } from "./units";
function display<T extends Partial<Record<IngredientNumericField, number>>>(
  input: T,
): T {
  const output = { ...input };
  // SAFETY: Estimators return only numeric composition fields, and conversion preserves the same keys.
  for (const key of Object.keys(input) as (keyof T &
    IngredientNumericField)[]) {
    // SAFETY: Each input property is numeric and remains numeric after unit conversion.
    output[key] = ingredientValueToDisplay(key, input[key]!) as T[typeof key];
  }
  return output;
}
export function calculateDairyComposition(fatPct: number) {
  return display(calculateDairyCompositionValue(fatPct / 100));
}
export function calculateChocolateComposition(
  cocoaPct: number,
  cocoaFatPct: number,
  sugarsPct: number,
) {
  return display(
    calculateChocolateCompositionValue(
      cocoaPct / 100,
      cocoaFatPct / 100,
      sugarsPct / 100,
    ),
  );
}
export function calculateAlcoholComposition(alcoholPct: number) {
  return display(calculateAlcoholCompositionValue(alcoholPct / 100));
}
export function calculateSweetenerComposition(
  waterPct: number,
  pac: number,
  pod: number,
) {
  return display(
    calculateSweetenerCompositionValue(waterPct / 100, pac / 100, pod / 100),
  );
}
export function calculateStabilizerComposition(solidsPct: number) {
  return display(calculateStabilizerCompositionValue(solidsPct / 100));
}
export function calculateEmulsifierComposition(input: {
  emulsifierPct: number;
  solidsPct: number;
}) {
  return display(
    calculateEmulsifierCompositionValue({
      emulsifierPct: input.emulsifierPct / 100,
      solidsPct: input.solidsPct / 100,
    }),
  );
}
